import styled from '@emotion/styled';
import { ListItem, List, ListItemButton, ListItemText } from '@mui/material';
import { DateTime } from 'luxon';

import { ranges } from './helper';

const Container = styled.div`
  border-radius: 2px;
  padding: 1px;
  border: 1px solid ${props => props.theme.colors.border};
`;

const RangeMenu = ({ id, handleChange }) => {

  const handleRangeClick = (range) => {
    const { start, end } = range.getRange();
    handleChange({ $gte: start, $lte: end }, id);
  };

  return (
      <Container>
        <List sx={{backgroundColor: "background.paper"}} disablePadding>
        {ranges.map((range) => (
          <ListItem disablePadding key={range.label} onClick={() => handleRangeClick(range)}>
            <ListItemButton>
              <ListItemText>
                {range.label}
              </ListItemText>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      </Container>
  );
};

export default RangeMenu;